<template>
    <div>
        <h3 @click="enableDebug($event)" class="display-4">Manage Users</h3>

        <o-list-toolbar
            :filters-list="filter_list"
            :list-options="list_options"
            :new-to="{ name: 'user.create', params: { id: 0 } }"
            :query-select-options="options"
            :schema="schema"
            :search-fields-list="search_field_list"
            :selected-filter="selected_filter"
            @filter_changed="update_filter($event)"
            @options_changed="update_table($event)"
            @reset_table="reset_table"
            new-button-text="New User"
        >
        </o-list-toolbar>

        <b-table
            :fields="fields"
            :items="items"
            :sort-by="list_options.sort"
            :sort-desc="list_options.order == 'desc'"
            @sort-changed="change_sort"
            bordered
            class="o-list"
            head-variant="light"
            no-local-sorting
            striped
            thead-class="o-gradient-header"
        >
            <template slot="cell(email)" slot-scope="{ index, item }">
                {{ item.email }}
                <a
                    v-if="item.email"
                    :href="'mailto:' + item.email"
                    target="email"
                >
                    <email-icon />
                </a>
            </template>
            <template slot="cell(username)" slot-scope="{ index, item }">
                <router-link
                    :to="{ name: 'user.edit', params: { id: item.id } }"
                >
                    {{ item.username }}
                </router-link>
            </template>
            <template slot="cell(first_name)" slot-scope="{ index, item }">
                <default-display :value="item.first_name"></default-display>
            </template>
            <template slot="cell(last_name)" slot-scope="{ index, item }">
                <default-display :value="item.last_name"></default-display>
            </template>
            <template slot="cell(is_staff)" slot-scope="{ index, item }">
                <boolean-display :value="item.is_staff"></boolean-display>
            </template>
            <template slot="cell(is_active)" slot-scope="{ index, item }">
                <span class="badge badge-secondary" v-if="!item.is_active">
                    Inactive
                </span>
                <span class="badge badge-success" v-if="item.is_active">
                    Active
                </span>
            </template>

            <template slot="empty">
                <p>
                    <emoticon-sad-icon large></emoticon-sad-icon>
                </p>
                No Data Found. Please
                <router-link :to="{ name: 'user.create' }"
                    >create a new item</router-link
                >
            </template>
        </b-table>

        <o-list-paging
            :limit="list_options.limit"
            :offset="list_options.offset"
            :page-options="rows_per_page_items"
            :total-items="total_items"
            @change-limit="change_limit"
            @change-page="change_page"
        />
    </div>
</template>

<style></style>

<script>
import {
    CreateCodeTableFetchMixin,
    CreateGroupPermissionMixin,
    CreateListPageMixin,
} from "../../../mixins";
import {
    fieldToTableColumn,
    GetSearchFields,
} from "../../../schema/schema_utils";
import schema from "../../schema/index";

import OListToolbar from "../../../components/list/OListToolbar";
import OListPaging from "../../../components/list/OListPaging";
import DefaultDisplay from "../../../components/display/DefaultDisplay";
import DateDisplay from "../../../components/display/DateDisplay";
import NumberDisplay from "../../../components/display/NumberDisplay";
import BooleanDisplay from "../../../components/display/BooleanDisplay";
import LookupDisplay from "../../../components/display/LookupDisplay";
import EmoticonSadIcon from "vue-material-design-icons/EmoticonSad";
import EmailIcon from "vue-material-design-icons/Email";
import LinkIcon from "vue-material-design-icons/Link";

export default {
    components: {
        EmoticonSadIcon,
        EmailIcon,
        LinkIcon,
        OListPaging,
        OListToolbar,
        DateDisplay,
        DefaultDisplay,
        BooleanDisplay,
        NumberDisplay,
        LookupDisplay,
    },
    mixins: [
        CreateListPageMixin("User", "user"),
        CreateGroupPermissionMixin("User"),
        CreateCodeTableFetchMixin([]),
    ],

    data: function () {
        return {
            schemaModel: schema.User,

            search_field_list: GetSearchFields(schema.User),

            filter_list: [
                {
                    name: "Active",
                    code: "active",
                    options: { offset: 0, sort: "email" },
                },
                {
                    name: "Non Active",
                    code: "inactive",
                    options: { offset: 0, sort: "email" },
                },
                {
                    name: "All",
                    code: "all",
                    options: { offset: 0, sort: "email" },
                },
            ],
        };
    },
    computed: {
        options() {
            return {};
        },
        fields() {
            return [
                fieldToTableColumn(this.schema, "username"),
                fieldToTableColumn(this.schema, "first_name"),
                fieldToTableColumn(this.schema, "last_name"),
                fieldToTableColumn(this.schema, "email"),
                fieldToTableColumn(this.schema, "is_staff"),
                fieldToTableColumn(this.schema, "is_active"),
            ];
        },
    },
};
</script>
